/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrAllowlistConfig } from './irrAllowlistConfig';


export interface IrrSaasNetwork { 
    cspConsole?: string;
    cspBackend?: string;
    console?: string;
    backend?: string;
    consoleSettings?: string;
    asupBackend?: string;
    consoleSettingsEnforcement?: string;
    consoleSettingsVcs?: string;
    consoleSettingsSddcVmc?: string;
    consoleSettingsSddcEvs?: string;
    consoleSettingsSddcGcve?: string;
    consoleSettingsEdrCb?: string;
    consoleSettingsEdrCws?: string;
    allowlistConfig?: IrrAllowlistConfig;
}

